import * as React from 'react';
const fullClone = Object.assign({}, React);
const {
  useId
} = fullClone;
const useEmptyId = () => '';
const useThemeKey = typeof useId === 'undefined' ? useEmptyId : useId;
export default useThemeKey;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/config-provider/hooks/useThemeKey.js
// module id = 3546
// module chunks = 0